/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TransPb } from "../../../../gen/body/trans";
import { KeyframeTrans } from "../../../../gen/skills/keyframe_trans";

export const protobufPackage = "skills";

export interface KeyframeActionArgs {
  /** list of keyframes, i.e. orientation and translation for a set of points */
  keyframeList: KeyframeTrans[];
  speed: number;
  dynamicBraking: boolean;
  poseGraphLogDir: string;
  navTTakeoff: TransPb | undefined;
}

export interface KeyframeResultData {
}

export interface KeyframeActionStateData {
}

function createBaseKeyframeActionArgs(): KeyframeActionArgs {
  return { keyframeList: [], speed: 0, dynamicBraking: false, poseGraphLogDir: "", navTTakeoff: undefined };
}

export const KeyframeActionArgs = {
  encode(message: KeyframeActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.keyframeList) {
      KeyframeTrans.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.speed !== 0) {
      writer.uint32(21).float(message.speed);
    }
    if (message.dynamicBraking === true) {
      writer.uint32(24).bool(message.dynamicBraking);
    }
    if (message.poseGraphLogDir !== "") {
      writer.uint32(34).string(message.poseGraphLogDir);
    }
    if (message.navTTakeoff !== undefined) {
      TransPb.encode(message.navTTakeoff, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeyframeActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyframeActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.keyframeList.push(KeyframeTrans.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.speed = reader.float();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.dynamicBraking = reader.bool();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.poseGraphLogDir = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.navTTakeoff = TransPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyframeActionArgs {
    return {
      keyframeList: globalThis.Array.isArray(object?.keyframeList)
        ? object.keyframeList.map((e: any) => KeyframeTrans.fromJSON(e))
        : [],
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : 0,
      dynamicBraking: isSet(object.dynamicBraking) ? globalThis.Boolean(object.dynamicBraking) : false,
      poseGraphLogDir: isSet(object.poseGraphLogDir) ? globalThis.String(object.poseGraphLogDir) : "",
      navTTakeoff: isSet(object.navTTakeoff) ? TransPb.fromJSON(object.navTTakeoff) : undefined,
    };
  },

  toJSON(message: KeyframeActionArgs): unknown {
    const obj: any = {};
    if (message.keyframeList?.length) {
      obj.keyframeList = message.keyframeList.map((e) => KeyframeTrans.toJSON(e));
    }
    if (message.speed !== 0) {
      obj.speed = message.speed;
    }
    if (message.dynamicBraking === true) {
      obj.dynamicBraking = message.dynamicBraking;
    }
    if (message.poseGraphLogDir !== "") {
      obj.poseGraphLogDir = message.poseGraphLogDir;
    }
    if (message.navTTakeoff !== undefined) {
      obj.navTTakeoff = TransPb.toJSON(message.navTTakeoff);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyframeActionArgs>, I>>(base?: I): KeyframeActionArgs {
    return KeyframeActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyframeActionArgs>, I>>(object: I): KeyframeActionArgs {
    const message = createBaseKeyframeActionArgs();
    message.keyframeList = object.keyframeList?.map((e) => KeyframeTrans.fromPartial(e)) || [];
    message.speed = object.speed ?? 0;
    message.dynamicBraking = object.dynamicBraking ?? false;
    message.poseGraphLogDir = object.poseGraphLogDir ?? "";
    message.navTTakeoff = (object.navTTakeoff !== undefined && object.navTTakeoff !== null)
      ? TransPb.fromPartial(object.navTTakeoff)
      : undefined;
    return message;
  },
};

function createBaseKeyframeResultData(): KeyframeResultData {
  return {};
}

export const KeyframeResultData = {
  encode(_: KeyframeResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeyframeResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyframeResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): KeyframeResultData {
    return {};
  },

  toJSON(_: KeyframeResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyframeResultData>, I>>(base?: I): KeyframeResultData {
    return KeyframeResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyframeResultData>, I>>(_: I): KeyframeResultData {
    const message = createBaseKeyframeResultData();
    return message;
  },
};

function createBaseKeyframeActionStateData(): KeyframeActionStateData {
  return {};
}

export const KeyframeActionStateData = {
  encode(_: KeyframeActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeyframeActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyframeActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): KeyframeActionStateData {
    return {};
  },

  toJSON(_: KeyframeActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyframeActionStateData>, I>>(base?: I): KeyframeActionStateData {
    return KeyframeActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyframeActionStateData>, I>>(_: I): KeyframeActionStateData {
    const message = createBaseKeyframeActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
